var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-ticket-wrapper"},[_c('SignupOverlay',[_c('Heading',{attrs:{"level":"4"}},[_vm._v(" Бронювання ")]),_c('Stepper',{attrs:{"steps":_vm.steps}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }